import { getCountries } from '../../actions/userActions/countryAction';
import { addCities, getCities } from '../../actions/userActions/cityAction';
import { addDesignationLevel, getDesignationsLevel } from '../../actions/userActions/designationLevelAction';
import { addDesignations } from '../../actions/userActions/designationAction';
import { getPracticeLocationTypes, addPracticeLocation, getLocationSuggestions } from '../../actions/userActions/practiceLocationAction';
import { addDepartments, getDepartments } from '../../actions/userActions/departmentAction';
import { addRoles } from '../../actions/userActions/roleAction'; 
import { addPermissions, getAllPermissions, getAllPermissionsGroup } from "../../actions/userActions/permissionsAction";
import { getEmploymentStatuses, addEmploymentStatuses } from '../../actions/userActions/employmentStatusAction';
import { addTeams, getTeams } from '../../actions/userActions/teamAction';
import { addOfficeLocation } from '../../actions/userActions/officelocationAction';
import { addDoctorRanks } from '../../actions/userActions/doctorRankAction';
import { addDoctorSpecializations } from '../../actions/userActions/doctorSpecializationAction';
import { addCustomerRank } from '../../actions/userActions/customerRankAction';
import { t } from '../../locales/translate';
import { addSubTasks } from '../../actions/userActions/subTaskAction';

export const formConfigs = {
  
  city: {
    requiredPermission: "CanAddCity",
    initialValues: { name: "", shortName: "", countryId: "" },
    validateKey: "city",
    fields: [
      { name: "name", label: t("city"), type: "text" },
      { name: "shortName", label: t("shortName"), type: "text" },
      { 
        name: "countryId", 
        label: t("country"), 
        type: "select", 
        optionsSelector: state => {
          const countriesData = state.countries_reducer.countries;
          return countriesData?.result?.map(country => ({
            value: country.id,
            label: country.name,
          })) || [];
        }
      }
    ],
    addAction: (data) => addCities(data),
    fetchDependencies: (dispatch) => dispatch(getCountries())
  },

  designation: {
    requiredPermission: "CanAddDesignation",
    initialValues: { name: "", shortName: "", description: "", active: true, levelId: "" },
    validateKey: "designation",
    fields: [
      { name: "name", label: t("name"), type: "text" },
      { name: "shortName", label: t("shortName"), type: "text" },
      { 
        name: "levelId", 
        label: t("designationLevel"), 
        type: "select", 
        isSearchable: true,
        optionsSelector: state => {
          const levelsData = state.designationLevels_reducer.designationLevels;
          return levelsData?.result
            ?.filter(level => level.active)
            ?.sort((a, b) => a.name.localeCompare(b.name))
            ?.map(level => ({ 
              value: level.id, 
              label: level.name 
            })) || [];
        }
      },
      { name: "description", label: t("description"), type: "textarea" },
    ],
    addAction: (data) => addDesignations(data),
    fetchDependencies: (dispatch) => dispatch(getDesignationsLevel(-1, 10, ''))
  },

  practiceLocation: {
    requiredPermission: "CanAddPracticeLocation",
    initialValues: { name: "", type: "", city: "", address: "" },
    validateKey: "practicelocation",
    fields: [
      { 
        name: "name", 
        label: t("name"), 
        type: "text",
        suggestions: {
          fetch: (query) => getLocationSuggestions(query),
          minChars: 3
        }
      },
      { 
        name: "type", 
        label: t("locationType"), 
        type: "select", 
        optionsSelector: state => {
            const typesData = state.practiceLocations_reducer.practiceLocationTypes;
            return typesData?.result?.map(type => ({
                value: type.id,
                label: type.name,
            })) || [];
        }
      },
      { 
        name: "city",
        label: t("city"), 
        type: "select", 
        optionsSelector: state => {
          const citiesData = state.cities_reducer.cities;
          return citiesData?.result?.map(city => ({
            value: city.id,
            label: city.name,
          })) || [];
        }
      },
      { name: "address", label: t("address"), type: "text" }
    ],
    addAction: (data) => addPracticeLocation(data),
    fetchDependencies: (dispatch) => {
      dispatch(getPracticeLocationTypes(-1));
      dispatch(getCities({
        filter: { textSearch: "", countryId: 1 },
        pageNumber: -1,
        pageSize: 0
      }));
    }
  },

  department: {
    requiredPermission: "CanAddDepartment",
    initialValues: { name: "", description: "", active: true },
    validateKey: "department",
    fields: [
      { name: "name", label: t("name"), type: "text" },
      { name: "description", label: t("description"), type: "textarea" }
    ],
    addAction: (data) => addDepartments(data),
    fetchDependencies: (dispatch) => dispatch(getDepartments())
  },

  role: {
    requiredPermission: "CanAddRole",
    initialValues: { name: "", description: "", roleGroup: [], active: true },
    validateKey: "role",
    fields: [
      { name: "name", label: t("name"), type: "text" },
      { 
        name: "roleGroup", 
        label: t("permissionGroup"), 
        type: "multiselect", 
        optionsSelector: state => {
          const permissionGroups = state.permissions_reducer.allPermissionsGroup;
          return permissionGroups?.result
              ?.filter(permissionGroup => permissionGroup.active)
              ?.sort((a,b) => a.name.localeCompare(b.name))
              ?.map(permissionGroup => ({ 
                value: permissionGroup.id, 
                label: permissionGroup.name 
              })) || [];
        }
      },
      { name: "description", label: t("description"), type: "textarea" },
    ],
    addAction: (data) => addRoles(data),
    fetchDependencies: (dispatch) => dispatch(getAllPermissionsGroup(-1))
  },

  employmentStatus: {
    requiredPermission: "CanAddEmploymentStatus",
    initialValues: { name: "", description: "", active: true },
    validateKey: "employeementstatus",
    fields: [
      { name: "name", label: t("name"), type: "text" },
      { name: "description", label: t("description"), type: "textarea" }
    ],
    addAction: (data) => addEmploymentStatuses(data),
    fetchDependencies: (dispatch) => dispatch(getEmploymentStatuses())
  },

  team: {
    requiredPermission: "CanAddTeam",
    initialValues: {name: "", description: "", active: true},
    validateKey: "team",
    fields: [
      {name: "name", label: t("name"), type: "text"},
      { name: "description", label: t("description"), type: "textarea" }
    ],
    addAction: (data) => addTeams(data),
    fetchDependencies: (dispatch) => dispatch(getTeams())
  },
  
  officeLocation: {
    requiredPermission: "CanAddOfficeLocation",
    initialValues: {address: "", cityId: "", cityName: "", contact1: "", isHeadOffice: true},
    validateKey: "officeLocation",
    fields: [
      {name: "address", label: t("address"), type: "text"},
      { 
        name: "cityId", 
        label: t("city"), 
        type: "select", 
        optionsSelector: state => {
          const citiesData = state.cities_reducer.cities;
          return citiesData?.result?.map(city => ({
            value: city.id,
            label: city.name,
          })) || [];
        }
      },
      {name: "contact1", label: t("contact1"), type: "text"},
      { name: "isHeadOffice", label: t("headOffice"), type: "checkbox" }
    ],
    addAction: (data) => addOfficeLocation(data),
    fetchDependencies:(dispatch) => dispatch(getCities({
        filter: { textSearch: "", countryId: 1 },
        pageNumber: -1,
        pageSize: 0
      }))
  },

  doctorDesignation:{
    requiredPermission: "CanAddDoctorRank",
    initialValues: {name: "", description: "", active: true},
    validateKey: "doctordesignation",
    fields: [
      {name: "name", label: t("name"), type: "text"},
      { name: "description", label: t("description"), type: "textarea" },
    ],
    addAction: (data) => addDoctorRanks(data),
  },

  doctorSpecialization:{
    requiredPermission: "CanAddDoctorSpecialization",
    initialValues: {name: "", description: ""},
    validateKey: "doctorSpecialization",
    fields: [
      {name: "name", label: t("name"), type: "text"},
      { name: "description", label: t("description"), type: "textarea" },
    ],
    addAction: (data) => addDoctorSpecializations(data),
  },

  customerRank:{
    requiredPermission: "CanAddCustomerRank",
    initialValues: {name: "", description: ""},
    validateKey: "rank",
    fields: [
      {name: "name", label: t("name"), type: "text"},
      { name: "description", label: t("description"), type: "textarea" },
    ],
    addAction: (data) => addCustomerRank(data),
  },
  
  subTask:{
    requiredPermission: "CanAddSubTask",
    initialValues: {name: "", description: "", active: true},
    validateKey: "subtask",
    fields: [
      {name: "name", label: t("name"), type: "text"},
      { name: "description", label: t("description"), type: "textarea" },
    ],
    addAction: (data) => addSubTasks(data),
  },  

  permissionGroup: {
    initialValues: {
      name: "",
      description: "",
      active: true,
      permissionIds: []
    },
    validateKey: "permissionGroup",
    fields: [
      {
        name: "name",
        label: t("name"),
        type: "text"
      },
      {
        name: "permissionIds",
        label: t("permissions"),
        type: "multiselect",
        optionsSelector: (state) =>
          state.permissions_reducer.allPermissions?.result?.map(
            (p) => ({
              value: p.id,
              label: p.name
            })
          ) || []
      },
      {
        name: "description",
        label: t("description"),
        type: "textarea"
      },
    ],
    addAction: (data) => addPermissions(data),
    fetchDependencies: (dispatch) =>
      dispatch(
        getAllPermissions({
          filter: {
            textSearch: "",
            permissionGroup: [0]
          },
          pageNumber: -1,
          pageSize: 0
        })
      )
  },

  designationLevel:{
    requiredPermission: "CanAddDesignationLevel",
    initialValues: {name: "", description: "", active: true},
    validateKey: "designationLevel",
    fields: [
      {name: "name", label: t("name"), type: "text"},
      { name: "description", label: t("description"), type: "textarea" },
    ],
    addAction: (data) => addDesignationLevel(data),
  },  

};